module.exports = __webpack_public_path__ + "static/media/1004.062d0594.png";